import { render, staticRenderFns } from "./writecard.vue?vue&type=template&id=656c627d&scoped=true&"
import script from "./writecard.vue?vue&type=script&lang=js&"
export * from "./writecard.vue?vue&type=script&lang=js&"
import style0 from "./writecard.vue?vue&type=style&index=0&id=656c627d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656c627d",
  null
  
)

export default component.exports